import React from "react";
import "./ErrorPage.css";

interface ErrorPageProps {
  message?: string;
}

const ErrorPage: React.FC<ErrorPageProps> = ({ message }) => (
  <div className="error-container">
    <h2 className="error-title">Ocurrió un error</h2>
    <p className="error-message">
      {message ??
        "No fue posible procesar tu solicitud. Por favor intenta nuevamente."}
    </p>
  </div>
);

export default ErrorPage;
